import { Root as TogglePrimitive } from '@radix-ui/react-toggle-group';
import React from 'react';

const ToggleGroup = React.forwardRef<
    React.ElementRef<typeof TogglePrimitive>,
    React.ComponentPropsWithoutRef<typeof TogglePrimitive>
>(({ ...props }, ref) => (
    <TogglePrimitive
        ref={ref}
        {...props}
    />
));

ToggleGroup.displayName = 'ToggleGroup';

export { ToggleGroup };
